import React, { useEffect, useState } from 'react';
import { RemoteComponent } from '@components/RemoteComponent';
import { Empty } from '@whalecloud/fdx';
import cloneDeep from 'lodash/cloneDeep';

const Remote = ({ element, updateElement, nameSpace, activeModal }) => {
  const { componentSettings, className, settings } = element.data;
  const { width, visible } = settings;
  const {
    url = '',
    parameter = "",
    formValues = {}
  } = componentSettings;

  const parameters = parameter ? JSON.parse(parameter) : {}

  const callBack = (result) => {
    const newElement = cloneDeep(element)
    newElement.data.componentSettings.externalAttributes = cloneDeep(result)
    updateElement({
      element: newElement
    }, nameSpace);
  }

  return (
    <div className={className} style={{ width: width.value, display: visible === 'hidden' ? "none" : "block" }} >
      {
        url ? (<RemoteComponent url={url} formValues={formValues} {...parameters} callBack={callBack} />) : (
          <Empty description="This component requires a URL to render." />
        )
      }
    </div>
  );
};

export default Remote;
